import Service from "../../Services";

const TCDCMini = {
  namespaced : true,
  state : {
    form : {
      id:'',
      branch_id : '',
      branch_name_th : '',
      branch_name_en : '',
      detail_th : '',
      detail_en : '',
      image_cover_desktop_path : '',
      image_cover_desktop_path_show : '',
      image_cover_desktop_name : '',
      image_cover_mobile_path : '',
      image_cover_mobile_path_show : '',
      image_cover_mobile_name : '',
      is_default_display : true,
      zone : '',
      type_id : '',
      type_name : '',
      orders : ''
    }
  },
  mutations : {
    GET_FORM:(state,res)=>{
      state.form = res;
    },
    CLEAR_FORM_DATA :(state)=>{
      state.form = {
        id:'',
        branch_id : '',
        branch_name_th : '',
        branch_name_en : '',
        detail_th : '',
        detail_en : '',
        image_cover_desktop_path : '',
        image_cover_desktop_path_show : '',
        image_cover_desktop_name : '',
        image_cover_mobile_path : '',
        image_cover_mobile_path_show : '',
        image_cover_mobile_name : '',
        is_default_display : true,
        zone : '',
        type_id : '',
        type_name : '',
        orders : ''
      }
    }
  },
  actions : {
    getTCDCMini({commit},{page,search,sort}){
      return Service.TCDCMiniAPI.getTCDCMini(page,search,sort);
    },
    showTCDCMini({commit},id){
      return Service.TCDCMiniAPI.showTCDCMini(id);
    },
    saveTCDCMini({commit},{id,data}){
      if(id){
        return Service.TCDCMiniAPI.updateTCDCMini(id,data);
      }else{
        return Service.TCDCMiniAPI.createTCDCMini(data);
      }
    },
    getAllTCDCMini() {
      return Service.TCDCMiniAPI.getAllTCDCMini();
    },
    getTCDCMiniByBranch({commit},branch_id){
      return Service.TCDCMiniAPI.getMiniByBranchId(branch_id);
    },
    deleteTCDCMini({commit},id){
      return Service.TCDCMiniAPI.deleteTCDCMini(id);
    },
    setFormTCDCMini({commit},res){
      commit('GET_FORM',res);
    },
    clearFormData({commit}){
      commit('CLEAR_FORM_DATA');
    }
  },
}
export default TCDCMini
